import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'

import {
  Button as ReactstrapButton
} from 'reactstrap'

import {
  makeTranslationAware
} from '../../../utils'

const StyledReactstrapButton = styled(ReactstrapButton)`
  background-color:transparent !important;
  padding: 0 0 0.3rem 1rem !important;
  color: #525656 !important;
  border: 0px !important;
  font-size: 1rem !important;

  &:hover {
    color: #00a79d !important;
  }
  &:focus {
    color: #00a79d !important;
    box-shadow: none!important;
  }
  margin-bottom: 0.5rem !important;
  @media only screen and (max-width: 540px) {
    margin-bottom: 0.5rem !important;
    padding: 0rem !important;
    white-space:pre-line !important;
    text-align: left !important;
  }
`

export const RawButton = ({ children, href, ...props }) => {
  return (
        <StyledReactstrapButton
            href={ href }
            tag={ href ? 'a' : 'button' }
            size="lg"
            { ...props }
        >
            { children }
        </StyledReactstrapButton>
  )
}

const TranslatedButton = makeTranslationAware(RawButton)
TranslatedButton.displayName = 'TranslatedButton'

export default TranslatedButton



// WEBPACK FOOTER //
// ./src/components/atoms/LinkNoPadding/LinkNoPadding.js